import axios from 'axios';
import { TokenEnum } from '../constants/user_constants';

const api = axios.create({
  baseURL: process.env.REACT_APP_ISTANBUL_URL,
  withCredentials: true,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem(TokenEnum.ACCESS_TOKEN);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && originalRequest._retry !== true && originalRequest.url !== '/auth/refresh') {
      originalRequest._retry = true;
      try {
        let newToken = null
        if(process.env.REACT_APP_AUTH_REQUIRED === 'true'){
          const res = await api.post('/auth/refresh');
          newToken = res.data.access_token;
        } else {
          const res = await api.post('/auth/application-login');
          newToken = res.data.access_token;
        }
        localStorage.setItem(TokenEnum.ACCESS_TOKEN, newToken);
        api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        window.location.href = `/login${window.location.search}`
      }
    }

    return Promise.reject(error);
  }
);

export default api;